import React, { Component } from "react";
import firebase from "../Firebase";
import Card from '../components/card'
import Banner from '../img/header.png'



class Detail extends Component {
	constructor(props) {
		super(props);
		this.ref = firebase.firestore().collection("content")
    .where("page", "==", "about");
		this.unsubscribe = null;
		this.state = {
			boards: [],
		};

	}
	onCollectionUpdate = (querySnapshot) => {
		const boards = [];
		querySnapshot.forEach((doc) => {
			const {
				heading,
				subheading,
				page,
				image,
				content,
			
			} = doc.data();
			boards.push({
				key: doc.id,
				doc, // DocumentSnapshot
        heading,
				subheading,
				page,
				image,
				content,
			});
	
		});
		this.setState({
			boards,
		});
	};
	
	componentDidMount() {
		this.unsubscribe = this.ref.onSnapshot(this.onCollectionUpdate);

	}


	render() {
		return (
			<div>
				 <img src={Banner} width="100%" alt="Roaring Fork Conservancy"/>
				<div className='body'>
        {this.state.key}
					{this.state.boards.map((board) => (
				<div>
                      <Card
                      heading={board.heading}
                      subheading={board.subheading}
                      content=  {board.content}
                      image={board.image}
                      width="325px"
                       />
										</div>
									))}		
	</div>
			</div>
		);
	}
}

export default Detail;
